angular.module("vgresiduos").controller("CostCenterEditCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/centro-de-custo/${$stateParams.id}`);
		};
	}
]);
